import { render, staticRenderFns } from "./design.vue?vue&type=template&id=1ab0a877&"
import script from "./design.vue?vue&type=script&lang=js&"
export * from "./design.vue?vue&type=script&lang=js&"
import style0 from "./design.vue?vue&type=style&index=0&id=1ab0a877&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ab0a877')) {
      api.createRecord('1ab0a877', component.options)
    } else {
      api.reload('1ab0a877', component.options)
    }
    module.hot.accept("./design.vue?vue&type=template&id=1ab0a877&", function () {
      api.rerender('1ab0a877', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gen/design.vue"
export default component.exports